












































































import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { i18n } from "@/resources/locales";
import { mixins } from "vue-class-component";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Validate } from "vuelidate-property-decorators";
import { required, sameAs } from "vuelidate/lib/validators";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";

@Component({
  name: "profile-security-component",
})
export default class SecurityComponent extends mixins(NotificationEvent) {
  @Prop({ default: "" }) token: string;
  @Validate({ required })
  password = "";
  @Validate({
    required,
    sameAs: sameAs("password"),
  })
  confirmPassword = "";
  hasVisiblePassword = false;
  loading = false;
  user: UserInterface;
  constructor() {
    super();
    this.user = this.$store.getters["UserStore/getUser"];
  }
  updateUserPassword(): void {
    if (this.getProgress(this.password) > 20) {
      this.loading = true;
      if (this.token === "") {
        this.$store.dispatch("UserStore/updateUserAction", {
          userId: this.user.id,
          props: {
            plainPassword: this.password,
          },
          callback: (user) => {
            this.loading = false;
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.userUpdate")
            );
          },
          callbackError: () => {
            this.loading = false;
            this.onError(
              "",
              i18n.t("notifications.errorMessages.updatePerfil")
            );
          },
        });
      } else {
        this.$store.dispatch("AuthStore/resetPasswordAction", {
          token: this.token,
          data: {
            password: this.password,
          },
          callback: () => {
            this.loading = false;
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.resetPassword")
            );
            this.$router.push("auth/login");
          },
          callbackError: () => {
            this.loading = false;
            this.onError(
              "",
              i18n.t("notifications.errorMessages.resetPassword")
            );
          },
        });
      }
    }
  }
  getProgress(value: string): number {
    let progress = 0;

    // more than 5 digits
    if (value.length >= 6) {
      progress += 20;
      // at least one number
      if (/\d/.test(value)) {
        progress += 20;
      }
      if (/(.*[A-Z].*)/.test(value)) {
        progress += 20;
      }
      // at menons a lowercase
      if (/(.*[a-z].*)/.test(value)) {
        progress += 20;
      }
      // at least one special character
      if (/[^A-Za-z0-9]/.test(value)) {
        progress += 20;
      }
    } else if (value.length > 1) {
      progress = 20;
    }

    return progress;
  }
}
